// import Link from "next/link";
// import NextImage from "../../common/NextImage";
// import LABELS from "@/components/global-constant/src/general";

// export default function LogoV2() {



//   // TODO: Use the admin-configured logo when dynamic branding is implemented.

//   const desktopLogoUrl = "/assets/site/images/Iayur_logo.png";
//   const mobileLogoUrl = "/assets/site/images/Iayur_logo.png"; // Fallback to main brand logo asset

//   return (
//     <Link 
//       href="/" 
//       aria-label={`${LABELS.SITE_NAME} Homepage`}
//       className="shrink-0 block hover:opacity-90 active:scale-[0.98] transition-all duration-200"
//     >
//       {/* Desktop Logo Layout */}
//       <div className="hidden sm:block relative w-[140px] h-[42px]">
//         <NextImage
//           src={desktopLogoUrl}
//           alt={`${LABELS.SITE_NAME} Logo`}
//           width={125}
//           height={42}
//           className="object-contain w-full h-full"
//           priority
//         />
//       </div>

//       {/* Mobile Logo Layout */}
//       <div className="block sm:hidden relative w-[160px] h-[48px] overflow-hidden">
//         <NextImage
//           src={mobileLogoUrl}
//           alt={`${LABELS.SITE_NAME} Mobile Logo`}
//           width={130}
//           height={48}
//           className="object-contain w-full h-full"
//           priority
//         />
//       </div>
//     </Link>
//   );
// }










// INDIAN AYUREVEDIC 



import Link from "next/link";
import NextImage from "../../common/NextImage";
import LABELS from "@/components/global-constant/src/general";

export default function LogoV2() {



  // TODO: Use the admin-configured logo when dynamic branding is implemented.

  const desktopLogoUrl = "/assets/site/images/Iayur_logo.png";
  const mobileLogoUrl = "/assets/site/images/Iayur_logo.png"; // Fallback to main brand logo asset

  return (
    <Link 
      href="/" 
      aria-label={`${LABELS.SITE_NAME} Homepage`}
      className="shrink-0 block hover:opacity-90 active:scale-[0.98] transition-all duration-200"
    >
      {/* Desktop Logo Layout */}
      <div className="hidden sm:block relative w-[220px] md:w-[240px] h-[52px] md:h-[58px]">
        <NextImage
          src={desktopLogoUrl}
          alt={`${LABELS.SITE_NAME} Logo`}
          width={240}
          height={58}
          className="object-contain w-full h-full"
          priority
        />
      </div>

      {/* Mobile Logo Layout */}
      <div className="block sm:hidden relative w-[180px] h-[50px] overflow-hidden">
        <NextImage
          src={mobileLogoUrl}
          alt={`${LABELS.SITE_NAME} Mobile Logo`}
          width={180}
          height={50}
          className="object-contain w-full h-full"
          priority
        />
      </div>
    </Link>
  );
}
